import React from "react";
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import SEO from "../components/seo";

const BlogPostTemplate = ({ data, location }) => {
  const post = data.wordpressPost;
  const siteTitle = data.site.siteMetadata?.title || `Title`;
  const { previous, next } = data;
  return (
    <Layout location={location} title={siteTitle}>
      <SEO title={post.title} description={post.excerpt || post.excerpt} />
      <article
        className="shadow "
        itemScope
        itemType="http://schema.org/Article"
      >
        <header className="relative">
          {data.wordpressPost.featured_media ? (
            <Img
              fluid={
                data.wordpressPost.featured_media.localFile.childImageSharp
                  .fluid
              }
              alt=""
              className="rounded-t border-black border-solid border-4 "
            />
          ) : (
            <div
              className="h-64 bg-cyan-600 bg-opacity-100 rounded-t border-black border-solid border-4"
              style={{ backgroundColor: "#8098ab" }}
            />
          )}
          <div className="absolute bottom-1/3 w-full">
            <h1
              itemProp="headline"
              dangerouslySetInnerHTML={{ __html: post.title }}
              className=" relative text-center text-white font-bold"
            />
          </div>

          <p className="absolute bottom-2 w-full text-right pr-2 text-white  font-medium">
            {post.date}
          </p>
        </header>

        <section
          dangerouslySetInnerHTML={{ __html: post.content }}
          itemProp="articleBody"
          className="p-2 post-content"
        />
        <hr />
        <footer></footer>
      </article>
      <nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: "1rem",
          }}
        >
          <li>
            {previous && (
              <Link to={"/" + previous.slug} rel="prev">
                <span
                  dangerouslySetInnerHTML={{ __html: "← " + previous.title }}
                />
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={"/" + next.slug} rel="next">
                <span dangerouslySetInnerHTML={{ __html: next.title + " →" }} />
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    wordpressPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY")
      featured_media {
        slug
        localFile {
          childImageSharp {
            fluid(maxWidth: 1000, maxHeight: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    previous: wordpressPost(id: { eq: $previousPostId }) {
      slug
      title
    }
    next: wordpressPost(id: { eq: $nextPostId }) {
      slug
      title
    }
  }
`;
